import { render, staticRenderFns } from "./trainingdetail.vue?vue&type=template&id=7e25e516&scoped=true&"
import script from "./trainingdetail.vue?vue&type=script&lang=js&"
export * from "./trainingdetail.vue?vue&type=script&lang=js&"
import style0 from "./trainingdetail.vue?vue&type=style&index=0&id=7e25e516&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e25e516",
  null
  
)

export default component.exports